import TablesPermission from 'pages/Administration/components/Table/TablesPermission'
import RolesTab from 'pages/Administration/Tabs/Roles'
import UsersTab from 'pages/Administration/Tabs/Users'
import ScenarioTab from 'pages/Administration/Tabs/Scenario'
import InstancesTab from 'pages/Administration/Tabs/Instances'
import OutputTab from './Tabs/Output'

export const frameworkComponents = {
  permissionRenderer: TablesPermission
}

const i18nActionKey = 'Administration:RolesManagement.Actions'

export const sidebarConfigComponents = {
  Roles: {
    Component: RolesTab
  },
  Users: {
    Component: UsersTab
  },
  Instances: {
    Component: InstancesTab
  },
  Scenario: {
    Component: ScenarioTab
  },
  Output: {
    Component: OutputTab
  }
}

export const defaultActions = {
  selected: [],
  empty: []
}

export const rowActions = {
  add: `${i18nActionKey}.AddRole`,
  delete: `${i18nActionKey}.Delete`,
  export: `${i18nActionKey}.ExportAll`,
  reset: `Common:ResetPermissions`
}

export const INSTANCE_TYPE = {
  SCENARIO: 'scenario',
  INSTANCE: 'instance'
}

export const DOM_LAYOUT = 'autoHeight'
export const FIELD_NAME = 'username'
export const EXTRA_HEADER_COMPONENT = 'extraComponent'
export const PAGINATION_PAGE_SIZE = 10
export const DETAIL_ROW_HEIGHT = 480
export const DEFAULT_HEADER_HEIGHT = 50
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const PREDEFINED_ROLES = [
  {
    id: 'admin',
    name: 'Admin',
    label: 'Admin'
  },
  {
    id: 'master',
    name: 'Master',
    label: 'Master'
  },
  {
    id: 'user',
    name: 'User',
    label: 'User'
  },
  {
    id: 'viewer',
    name: 'Viewer',
    label: 'Viewer'
  },
  {
    id: 'manager',
    name: 'Manager',
    label: 'Manager'
  }
]
